export enum ProfileEntry {
  Bio = 'bio',
  Education = 'education',
  Employment = 'employment',
  Industry = 'industry',
  Product = 'product',
}
